define([
  "base-view-model",
  "jquery",
  "knockout",
  "product-group-view-model",
  "cookies-factory"],
function (baseViewModel, $, ko, ProductGroupViewModel, cookiesFactory) {

  function ProductOptionViewModel(data, globals) {

    const { isSamplingEnabled, isSamplingEnabledCecOnly } = globals;
    var self = this;
    ko.utils.extend(self, baseViewModel);

    // This field is used for serverTemplate as Id
    this.optionid = data.OptionId;
    this.id = data.OptionId;
    this.name = data.ShortLabel;
    this.type = data.Type;
    self.groups = ko.observableArray([]);
    this.selectedChoiceIds = ko.observableArray();
    self.hideSection = ko.observable(false);
    self.isSamplingEnabled = ko.observable((isSamplingEnabled && !isSamplingEnabledCecOnly) || (cookiesFactory.isInternalUser() && isSamplingEnabledCecOnly));    

    this.unselectAll = function () {
      $.each(self.groups(), function (index, currentGroup) {
        currentGroup.unselectAll();
      });
    };

    var load = function () {
      var _groups = [];
      $.each(data.Groups, function (index, value) {
        _groups.push(new ProductGroupViewModel(value, value.Choices, data.OptionId));
      });
      self.groups.push.apply(self.groups, _groups);
    };

    load();

    this.toggleSection = function() {
      self.hideSection(!self.hideSection());
    };

  }

  return ProductOptionViewModel;

});
